'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LABEL_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__label--small'
};

var getClassName = function getClassName(className, error, readOnly, required, fieldSize) {
  return (0, _classNames2.default)('private-form__label', LABEL_SIZE_OPTIONS[fieldSize], className, {
    'private-form__label--readonly': readOnly,
    'private-form__label--required': required,
    'error-msg': error
  });
};

exports.default = _react2.default.createClass({
  displayName: 'UIFormLabel',

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    error: _react.PropTypes.bool.isRequired,
    htmlFor: _react.PropTypes.string,
    readOnly: _react.PropTypes.bool.isRequired,
    required: _react.PropTypes.bool.isRequired
  },

  contextTypes: {
    fieldSize: _react.PropTypes.oneOf(Object.keys(LABEL_SIZE_OPTIONS))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      required: false,
      readOnly: false
    };
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        error = _props.error,
        readOnly = _props.readOnly,
        required = _props.required,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'error', 'readOnly', 'required']);

    return _react2.default.createElement(
      'label',
      _extends({}, rest, {
        className: getClassName(className, error, readOnly, required, this.context.fieldSize)
      }),
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/form/UIFormLabel.js
// module id = 1096
// module chunks = 2 3